import React from "react";
import QuoteStepBase from '../../components/QuoteStepBase'
import { IQuoteStepState, IQuoteStepComponentProps } from "../../components/interfaces";
import { QuoteStep } from "./QuoteStepLayout";
import { connect } from "react-redux";
import { IBindResult } from "../../classes/ExternalQuote";
import { IAppState } from "../../state/interfaces";
import { quoteStepChanged } from "../../state/appActions";
import { FULL_QUOTE_STEPS } from "../../AppConstants";
import Utilities from "../../classes/Utilities";

interface IState extends IQuoteStepState {
}

interface IProps extends IQuoteStepComponentProps {
    bindResult: IBindResult | null
}

class QuoteDocuments extends QuoteStepBase<IProps, IState> {

    constructor(props: IProps) {
        super(props);

        this.state = {
            updatingStore: false,
            errors: null
        }
    }

    componentDidMount() {
        super.componentDidMount();
        this.props.reportCurrentStep();
    }

    render() {
        return (
            <QuoteStep id="finish" className="policy-details">
                <div className="titleArea">
                    <h5>Download policy documents</h5>
                </div>
                {
                    this.props.bindResult?.documents.map((document) => (
                        <p key={Utilities.uniqueId()}><i className="fas fa-file-download"></i> <a href={document.downloadUrl} target="_blank">{document.name}</a></p>    
                    ))
                }
            </QuoteStep>
        );
    }
}

let mapProps = (state: IAppState) => {
    return {
        bindResult: state.externalQuote?.bindResult
    };
};

let mapDispatch = (dispatch: any) => {
    return {
        reportCurrentStep: () => dispatch(quoteStepChanged(FULL_QUOTE_STEPS.FINISH))
    };
};

export default connect(mapProps, mapDispatch)(QuoteDocuments);
